module.exports = __webpack_public_path__ + "46d41bd6e6458f6fab313a38f2436a1e.png";